var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.994,
    height: 52.994,
    viewBox: "0 0 52.994 52.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.994,
    height: 52.994,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.091,
    height: 30.232,
    fill: "#f8f3ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H48.994a4,4,0,0,1,4,4V48.994a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0",
    fill: "#001233"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 11.381)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.418,1.029A3.444,3.444,0,0,1,7.467,3.592,3.4,3.4,0,0,1,6.418,6.115,3.647,3.647,0,0,1,3.754,7.144,3.717,3.717,0,0,1,1.07,6.115,3.365,3.365,0,0,1,0,3.592,3.412,3.412,0,0,1,1.07,1.029,3.717,3.717,0,0,1,3.754,0,3.647,3.647,0,0,1,6.418,1.029M.888,9.485H6.62V30.232H.888Z",
    transform: "translate(0 -0.001)",
    fill: "#f8f3ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.3ca72640a0de4f3ca681fdc52f25957b.svg";
export { ForwardRef as ReactComponent };